import Badge from '@/common/components/Badge';
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper';
import GoBackButton from '@/common/components/GoBackButton';
import Tabs from '@/common/components/Tabs'
import useCompany from '@/common/hooks/queries/useCompany'
import useUserPermissions from '@/common/hooks/useUserPermissions';
import { cn } from '@/common/utils/cn';
import { defaultTabs } from '@/features/privateCompanies/constants/companyTabs.constant'
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom'

const Show = () => {
  const { id } = useParams();

  const [isWrapped, setIsWrapped] = useState<boolean>(false);
  const listRef = useRef<HTMLDivElement>(null);
  const [tabsIsLoading, setTabIsLoading] = useState<boolean>(true)

  const {
    data: company,
    isPending: companyIsPending,
    error: companyError = {} as any,
    refetch: refetchCompany,
  } = useCompany({ id: id || '' })
  
  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions()

  const cmPermissions = [
    'Admin::Maintenance::Workflows::Filter',
    'Admin::Maintenance::Solicitations::Filter',
    'Admin::Maintenance::ScrapRules::Filter'
  ]

  const hasAnyCmPermission = cmPermissions.some((permission) => hasUserPermission(permission))

  const showMaintenanceTab = isUserPermissionsPending || hasAnyCmPermission

  useEffect(() => {
    const element = listRef.current;
    if (!element) return;

    const singleLineHeight = 40;

    const observer = new ResizeObserver(() => {
      if (!companyIsPending) {
        setIsWrapped(element.scrollHeight > singleLineHeight * 1.5);
        setTabIsLoading(false)
      }
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, [companyIsPending]);

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={companyError?.status}
      refetchFunction={refetchCompany}
    >
      <div className='max-h-[calc(100vh-64px)]'>
        <div className="flex justify-between items-center mb-6">
          <div className="flex gap-4 items-center">
            <GoBackButton
              fallback='/companies'
              searchLastRouteFromReference={`/companies/${id}`}
            />

            <h2 className="text-2xl font-bold">{company?.general_information?.fantasy_name}</h2>

            {company?.status === 'blocked' && (
              <Badge
                Icon={React.Fragment}
                text='Bloqueado'
              />
            )}

            {company?.status === 'disabled' && (
              <Badge
                Icon={React.Fragment}
                text='Desativado'
              />
            )}
          </div>
        </div>

        <Tabs
          tabsListClassName="flex h-auto flex-row flex-wrap justify-start w-full bg-transparent rounded-none"
          tabsListRef={listRef}
          tabsTriggerClassName={cn(
            "h-8 transition-none duration-0 rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800",
            !isWrapped && 'flex-1'
          )}
          tabsContentClassName="mt-6"
          tabsList={defaultTabs({
            companyKind: company?.kind,
            companyPaymentModality: company?.current_contract?.payment_modality,
            companyPriceSurveyMode: company?.price_survey_mode,
            remainingCredit: company?.remaining_credit,
            remainingBalance: company?.remaining_balance,
            showMaintenanceTab: showMaintenanceTab
          })}
          isLoading={tabsIsLoading}
        />
      </div>
    </ErrorMessageWrapper>
  )
}

export default Show
